import { render, staticRenderFns } from "./GroupView.vue?vue&type=template&id=3964cb0e&scoped=true&"
import script from "./GroupView.vue?vue&type=script&lang=ts&"
export * from "./GroupView.vue?vue&type=script&lang=ts&"
import style0 from "./GroupView.vue?vue&type=style&index=0&id=3964cb0e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3964cb0e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VBtn,VCard,VCardText,VSpacer,VToolbar,VToolbarTitle})
